import { createFileRoute, redirect } from "@tanstack/react-router";
import { PublicStudyGroupPage } from "@/features/all-study-groups/components/PublicStudyGroupPage";
import { getApiErrorStatus } from "@/lib/apiErrors";
import { authApi } from "@/lib/humhub-api/auth";
import { studyGroupsApi } from "@/lib/humhub-api/studyGroups";

export const Route = createFileRoute("/public-study-group/$study-group-guid")({
  beforeLoad: async ({ params }) => {
    const guid = params["study-group-guid"];

    let studyGroup: Awaited<
      ReturnType<typeof studyGroupsApi.getPublicStudyGroupByGuid>
    > | null = null;

    try {
      studyGroup = await studyGroupsApi.getPublicStudyGroupByGuid(guid);
    } catch (error) {
      if (getApiErrorStatus(error) === 404) {
        throw redirect({ to: "/not-found", replace: true });
      }
      throw error;
    }

    if (!studyGroup?.id) {
      throw redirect({ to: "/not-found", replace: true });
    }

    const me = await authApi.getCurrentUserOrNull();
    if (me) {
      window.location.replace(`/all-study-groups/${studyGroup.id}`);
      return;
    }
  },

  loader: async ({ params }) => {
    const guid = params["study-group-guid"];
    return { studyGroupGuid: guid };
  },

  staleTime: 0,
  component: PublicStudyGroupPage,
});
